import React, { FC } from 'react';
import { SettingsTablePageSkeleton } from '../settingsSkeleton';

export const ExtensionFieldsPageSkeleton: FC = () => <SettingsTablePageSkeleton />;
